module.exports = __webpack_public_path__ + "static/cafe3-743b5862ec9f50034afef38bf83afd75.jpg";